import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideTemplateForm from '../containers/CareGuideTemplateFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideTemplateEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideTemplateEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_template_route_edit')} />
          <CareGuideTemplateForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideTemplateEditScreen;

Logger.log('silly', `CareGuideTemplateEditScreen loaded.`);
